export default "__VITE_ASSET__a0610352__"